import { memoizeFunction } from "@fluentui/react/lib/Utilities";
import type { AppKeytipProps } from "./AppKeytip.types";

export const getTopLevelKeytipProps = memoizeFunction(
  (topLevelKeytip: string): AppKeytipProps => {
    const keytipSequence = topLevelKeytip.toLocaleLowerCase();
    return {
      content: topLevelKeytip,
      keySequences: [keytipSequence],
      hasMenu: true,
    };
  }
);
